/** Browser environment detection: SSOT for whether code is running in a browser and whether browser capabilities (localStorage) are available. Import this instead of writing `typeof window !== "undefined"` inline. */

import { recordStringOr } from '@federa/const/record-guards';

// Module-scoped DOM type declarations (Workers tsconfig lacks "dom" lib)
declare const window: undefined | Record<string, unknown>;
declare const localStorage: undefined | Record<string, unknown>;

export function isBrowser(): boolean {
	return typeof window !== 'undefined';
}

/** The page's current path, or `serverFallback` where there is no browser (a server render, a worker) or its location
 *  cannot be read. Each caller names its own fallback: the path a server render should act as if it were on. */
export function currentPathname(serverFallback: string): string {
	if (typeof window === 'undefined') return serverFallback;
	return recordStringOr(window.location, 'pathname', serverFallback);
}

/** Returns true when running in a browser with a usable localStorage. */
export function isLocalStorageAvailable(): boolean {
	if (!isBrowser()) return false;
	try {
		return typeof localStorage !== 'undefined';
	} catch {
		return false;
	}
}
